export interface NutritionalCompositionData {
  n: number;
  p2O5: number;
}

export enum StateOfMatterEnum {
  Solid = 'Solid',
  Liquid = 'Liquid',
}

export enum SkalTypeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum FertilizerTypeEnum {
  Synthetic = 'Synthetic',
  Animal = 'Animal',
  OtherOrganic = 'OtherOrganic',
  Compost = 'Compost',
  Lime = 'Lime',
  BioStimulator = 'BioStimulator',
}

export interface FertilizerData {
  fertilizerType: FertilizerTypeEnum;
  nutritionalComposition: NutritionalCompositionData;
}

export interface CropProtectionData {
  admissions: Admission[];
}

export enum UnitOfMeasurementEnum {
  G = 'G',
  KG = 'KG',
  T = 'Ton',
  ML = 'ML',
  L = 'L',
  ST = 'ST',
}

export interface CropAid {
  id: number;
  name: string;
  unitOfMeasurement: UnitOfMeasurementEnum;
  isActive: boolean;
  isFertilizer: boolean;
  fertilizer?: FertilizerData;
  cropProtection?: CropProtectionData;
}

export interface CropAidState {
  cropAids?: CropAid[];
}

export interface Admission {
  id: number;
  number: string;
}
